// Dependecies
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import { withTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { Pagination } from 'antd';
import 'antd/dist/antd.css';
import Alert from 'react-bootstrap/Alert';

// Component
import Template from '../../components/Template';
import PopUpDriverEdit from '../../components/PopUpDriverEdit';
import Spinner from '../../components/Spinner';

// helpers
import { patternEmail } from '../../helpers';

// Hooks
import useStatusService from '../../hooks/useStatusService';
import useUserRegisterWorkshop from '../../hooks/useUserRegisterWorkshop';

// Images
import edit from '../../../sass/images/workshop/icon-feather-edit.svg';
import alert from '../../../sass/images/alert/alert.svg';
import successAlert from '../../../sass/images/alert/icon-check-alert.svg';

function UserRegistrationWorkShop(props) {
  const { t } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [cardPerPage] = useState(6);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(cardPerPage);
  // change page
  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };
  const { newMaintenances } = useStatusService();
  const { register, handleSubmit, errors, reset, formState } = useForm({
    mode: 'onChange',
  });
  const {
    openModalEdit,
    closeModal,
    openModal,
    listUsers,
    driver,
    successfullyUpdate,
    submitAdd,
    messageErrorEmail,
    messageErrorId,
    reload,
    successfully,
    venues,
  } = useUserRegisterWorkshop(reset);
  const { isValid } = formState;

  return (
    <Template
      type={3}
      newMaintenances={newMaintenances}
      classNameContainer="maintenance"
      className="container_menu maintenance driver"
    >
      {!reload ? (
        <Spinner text={t('alert:reload')}> </Spinner>
      ) : (
        <>
          <PopUpDriverEdit
            isBlocked={openModal}
            close={closeModal}
            infoDriver={driver}
            success={successfullyUpdate}
          />
          <div className="content_dynamic history block-job-requests">
            <Row className="content_maintenace">
              <div className="header-content">
                <div className="info-tittle">
                  <h1 className="title-maintenances">{t('titleUserWorkshop')}</h1>
                  <p>{t('descriptionAssistant')}</p>
                </div>
              </div>
            </Row>
            <div className="block-form">
              <form onSubmit={handleSubmit((data) => submitAdd(data))}>
                <Row className="no-gutters">
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="name" className="col-form-label">
                      {t('name')} *
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    />
                    {errors.name && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="last_name" className="col-form-label">
                      {t('last_name')} *
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="last_name"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    />
                    {errors.last_name && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="identification" className="col-form-label">
                      {t('identification')} *
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="identification"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    />
                    {errors.identification && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="email" className="col-form-label">
                      {t('email')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      ref={register({
                        value: true,
                        required: true,
                        pattern: { value: patternEmail, message: t('login:invalid') },
                      })}
                    />
                    {errors.email && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.email.message ? (
                            <>{errors.email.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="phone" className="col-form-label">
                      {t('phone')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="phone"
                      ref={register({
                        value: true,
                        required: true,
                        maxLength: {
                          value: 10,
                          message: t('register:max-10'),
                        },
                        minLength: {
                          value: 10,
                          message: t('register:min-10'),
                        },
                        pattern: {
                          value: /[0-9]$/,
                          message: t('alert:number'),
                        },
                      })}
                    />
                    {errors.phone && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.phone.message ? (
                            <>{errors.phone.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job driver">
                    <label htmlFor="venue" className="col-form-label">
                      {t('venues')}*
                    </label>
                    <select
                      defaultValue=""
                      className="form-control"
                      id="venue"
                      name="venue"
                      ref={register({
                        required: {
                          value: true,
                          message: t('alert:required-field'),
                        },
                      })}
                    >
                      {venues.length > 0 ? (
                        <>
                          <option value="" disabled>
                            {t('select')}
                          </option>
                          {venues.map((venue) => (
                            <option value={venue.id} key={venue.id}>
                              {venue.address}
                            </option>
                          ))}
                        </>
                      ) : (
                        <option value="" disabled>
                          {t('select-workshop')}
                        </option>
                      )}
                    </select>
                    {errors.venue && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.venue.message ? (
                            <>{errors.venue.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={12} className="block-job driver">
                    <div className="block-button">
                      <button
                        id="BtnSubmit"
                        type="submit"
                        className={` btn btn-primary button-job driver ${
                          isValid ? '' : 'disabled'
                        }`}
                      >
                        {t('sendDriver')}
                      </button>
                      <br />
                      {messageErrorEmail && (
                        <div className="error_input alert">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {t('errorEmail')}
                          </p>
                        </div>
                      )}
                      {messageErrorId && (
                        <div className="error_input alert">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {t('errorId')}
                          </p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </form>
            </div>
            <Container key={1} className="main-card card-maintenances vehicle block-hidden driver">
              <Row className="no-gutters driver table-responsive">
                <table className="table table-hover">
                  <thead className="table-drivers">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col"> {t('name')}</th>
                      <th scope="col" className="table-desktop">
                        {t('last_name')}
                      </th>
                      <th scope="col"> {t('identification')}</th>
                      <th scope="col" className="table-desktop">
                        {t('email')}
                      </th>
                      <th scope="col" className="table-desktop">
                        {t('phone')}
                      </th>
                      <th scope="col" className="table-desktop">
                        {t('venues')}
                      </th>
                      <th scope="col" className="table-desktop">
                        {t('status')}
                      </th>
                      <th scope="col"> {t('action')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listUsers.map(
                      (userDriver, index) =>
                        index >= minIndex &&
                        index < maxIndex && (
                          <tr key={userDriver.id}>
                            <th scope="row">{index + 1} </th>
                            <td> {userDriver.name} </td>
                            <td className="table-desktop"> {userDriver.last_name} </td>
                            <td> {userDriver.identification} </td>
                            <td className="table-desktop"> {userDriver.email} </td>
                            <td className="table-desktop"> {userDriver.phone} </td>
                            <td className="table-desktop"> {userDriver.venue} </td>

                            {userDriver.id_status === 6 ? (
                              <td className="table-desktop"> {t('statusAct')}</td>
                            ) : (
                              <td className="table-desktop"> {t('statusIna')}</td>
                            )}
                            <td>
                              <button
                                type="submit"
                                className="edit-icon-company"
                                onClick={() => {
                                  openModalEdit(userDriver.id);
                                }}
                              >
                                <img src={edit} alt="Editar información" />
                              </button>
                            </td>
                          </tr>
                        )
                    )}
                  </tbody>
                </table>
              </Row>
              <Pagination
                className="col-12"
                size="small"
                defaultCurrent={1}
                total={listUsers.length}
                defaultPageSize={cardPerPage}
                current={currentPage}
                onChange={handleChange}
              />
            </Container>
            {successfully && (
              <Alert variant="success" className="alert-response">
                <img src={successAlert} alt={t('alt:successAlert')} /> &nbsp;&nbsp;{' '}
                <p>{t('alert:success')}</p>
              </Alert>
            )}
          </div>
        </>
      )}
    </Template>
  );
}

UserRegistrationWorkShop.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['driverRegistration', 'alert', 'alt', 'routers'])(
  UserRegistrationWorkShop
);
